module.exports = __webpack_public_path__ + "static/media/contact_header.ccda1364.jpg";